/**
 * @fileoverview Agent definition for chapter-architect-v2.
 *
 * Breaks down a complete story outline into a series of chapters.
 *
 * @category narrative.chapters.planning
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'chapter-architect-v2',
  kind: 'primitive',
  name: 'Chapter Architect',
  description: 'Breaks down a complete story outline into a series of chapters.',
  category: 'structure',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2024-06',
    lastUpdated: '2026-01',
    taxonomyPath: 'narrative.chapters.planning',
    usedBy: [
      'primitives/use-chapter-architect-v2.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'chapter-architect-remaining-v2',
      'chapter-planner-v2',
    ],
  },
};
